// extracted by css-extract-rspack-plugin
export default {"maxHeight":"ComponentsTabPanel_maxHeight__tlXSr"};